import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FramesWrapper, Frame, CheckButtonFrame, CheckButtonFrameTutor, CheckBoxTitleStudent, CheckBoxTitleTutor, StudentTutorLanguageWrapper, StudentTutorWrapper, LanguageButtonsWrapper, LanguageButton, InputWordWrapper, WordWrapper, Input, Word, WordSpan, TranslatSpan, LessonDivider, LessonLabel, LargeButtonsWrapper, LargeButton, NumberButtonWrapper, TopButton, BottomButton, PercentButton, ProgressBarStudent, ProgressBarTutor, Percent } from "./FrameStyle"
import { colors } from "../../../components/01_config/Colors"
import {
    toggleStudentWord,
    toggleTutorWord,
    setWordInput,
    toggleWordReveal,
    fetchVocabWords
} from "../../../features/vocab/vocabSlice"
import { vocabulary } from "../../../i18n/05_vocabulary"

const FrameComponent = ({ startTestMode, listOfWordsMode, oneThousand, setOneThousand }) => {
    const lang = useSelector(state => state.lang.lang)
    const t = vocabulary[lang]

    const role = useSelector((s) => s.auth?.user?.role);
    const selectedStudentId = useSelector((s) => s.teacher?.selectedStudentId);

    const isGuest = !role;

    const dispatch = useDispatch()

    const canStudentTick = role === "STUDENT" || isGuest;
    const canTutorTick = role === "TEACHER" && !!selectedStudentId;

    const [thousand, setThousand] = useState("First Thousand")

    const TOP_BUTTONS = [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1050];

    const [selectedTop, setSelectedTop] = useState(100);
    const [selectedBottom, setSelectedBottom] = useState(10);
    const [bottomNumbers, setBottomNumbers] = useState([]);
    const [isInitialized, setIsInitialized] = useState(false);


    const [bottomButtonValue, setBottomButtonValue] = useState(10)

    const getBottomButtonsForTop = (top) => {
        const MAX_WORD_ID = 1050;

        // Determine the start of the block
        const start = top === 1050 ? 1010 : top - 90;

        const result = [];
        for (let val = start; val <= top && val <= MAX_WORD_ID; val += 10) {
            result.push(val);
        }

        return result;
    };

    const isTenCompleteForTutor = (tenEnd) => {
        const startId = tenEnd - 9;
        const endId = tenEnd;

        // All ids in that range must exist and be correctTutor
        for (let id = startId; id <= endId; id++) {
            const w = oneThousand.find((x) => x.id === id);
            if (!w || !w.correctTutor) return false;
        }
        return true;
    };

    const getTenButtonsForTop = (top) => {
        // same as your getBottomButtonsForTop, but we’ll reuse it for “hundred completeness”
        const MAX_WORD_ID = 1050;

        const start = top === 1050 ? 1010 : top - 90;
        const result = [];
        for (let val = start; val <= top && val <= MAX_WORD_ID; val += 10) {
            result.push(val);
        }
        return result;
    };

    const isHundredCompleteForTutor = (top) => {
        const tensForThisTop = getTenButtonsForTop(top);
        return tensForThisTop.every((tenEnd) => isTenCompleteForTutor(tenEnd));
    };




    const [language, setLanguage] = useState("Eng")
    const [percentStudent, setPercentStudent] = useState()
    const [percentTutor, setPercentTutor] = useState()


    const clickLanguage = (e) => {
        if (e.target.id === "Eng") {
            setLanguage("Eng")
        } else {
            setLanguage("Ukr")
        }
    }

    const clickInputButton = (wordId, currentValue) => {

        if (isGuest) {
            setOneThousand((prev) =>
                prev.map((w) =>
                    w.id === wordId ? { ...w, correctStudent: !currentValue } : w
                )
            );
            return;
        }

        dispatch(toggleStudentWord({ wordId, nextValue: !currentValue }));
    }

    const clickInputButtonTutor = (wordId, currentValue) => {
        dispatch(
            toggleTutorWord({
                studentId: selectedStudentId,
                wordId,
                nextValue: !currentValue,
            })
        );
    }

    const fillInput = (wordId, text) => {

        if (isGuest) {
            setOneThousand((prev) =>
                prev.map((w) => (w.id === wordId ? { ...w, input: text } : w))
            );
            return;
        }

        dispatch(setWordInput({ wordId, text }));
    }

    const clickWord = (wordId) => {

        if (isGuest) {
            setOneThousand((prev) =>
                prev.map((w) =>
                    w.id === wordId
                        ? {
                            ...w,
                            display_translat:
                                w.display_translat === "hidden" ? "visible" : "hidden",
                        }
                        : w
                )
            );
            return;
        }

        dispatch(toggleWordReveal(wordId));
    }

    const clickTopButton = (topValue) => {
        setSelectedTop(topValue);

        const newBottoms = getBottomButtonsForTop(topValue);
        setBottomNumbers(newBottoms);
        const defaultBottom = newBottoms[0];
        setSelectedBottom(defaultBottom);
        setBottomButtonValue(defaultBottom);
    };

    const clickBottomButton = (bottomValue) => {
        setSelectedBottom(bottomValue);
        setBottomButtonValue(bottomValue);
    };



    useEffect(() => {
        if (isInitialized) return;
        if (!oneThousand || oneThousand.length === 0) return;

        const defaultTop = 100;
        const bottoms = getBottomButtonsForTop(defaultTop);

        setSelectedTop(defaultTop);
        setBottomNumbers(bottoms);
        setSelectedBottom(bottoms[0]);
        setBottomButtonValue(bottoms[0]);

        setIsInitialized(true);
    }, [oneThousand, isInitialized]);



    useEffect(() => {
        if (!oneThousand || oneThousand.length === 0) {
            setPercentStudent(0);
            setPercentTutor(0);
            return;
        }
        setPercentStudent(
            Math.trunc((oneThousand.filter((v) => v.correctStudent).length / 1050) * 100)
        );
        setPercentTutor(
            Math.trunc((oneThousand.filter((v) => v.correctTutor).length / 1050) * 100)
        );
    }, [oneThousand]);

    return (
        <FramesWrapper startTestMode={startTestMode} listOfWordsMode={listOfWordsMode}>
            <Frame>
                <StudentTutorLanguageWrapper>
                    <StudentTutorWrapper>
                        <CheckBoxTitleStudent>S</CheckBoxTitleStudent>
                        <CheckBoxTitleTutor>T</CheckBoxTitleTutor>
                    </StudentTutorWrapper>
                    <LanguageButtonsWrapper>
                        <LanguageButton onClick={clickLanguage} language={language} id="Eng">English</LanguageButton>
                        <LanguageButton onClick={clickLanguage} language={language} id="Ukr">Ukrainian</LanguageButton>
                    </LanguageButtonsWrapper>
                </StudentTutorLanguageWrapper>

                {(() => {
                    const visibleWords = oneThousand.filter(
                        (val) => val.id <= bottomButtonValue && val.id > bottomButtonValue - 10
                    );

                    return visibleWords.map((value, index) => {
                        const next = visibleWords[index + 1];

                        // ✅ preferred: divider when lesson changes
                        const lessonNow = String(value.lesson ?? "");
                        const lessonNext = String(next?.lesson ?? "");
                        const shouldShowDivider =
                            !!next && lessonNow && lessonNext && lessonNow !== lessonNext;

                        // ✅ fallback: divider every 35 if lesson missing
                        const fallbackDivider = !value.lesson && value.id % 35 === 0;

                        return (
                            <div key={value.id}>
                                <Word>
                                    <CheckButtonFrame
                                        onClick={
                                            canStudentTick
                                                ? () => clickInputButton(value.id, value.correctStudent)
                                                : undefined
                                        }
                                        disabled={!canStudentTick}
                                        correctStudent={value.correctStudent}
                                        correctTutor={value.correctTutor}
                                        style={{ display: "inline" }}
                                    />

                                    <CheckButtonFrameTutor
                                        onClick={
                                            canTutorTick
                                                ? () => clickInputButtonTutor(value.id, value.correctTutor)
                                                : undefined
                                        }
                                        disabled={!canTutorTick}
                                        correctStudent={value.correctStudent}
                                        correctTutor={value.correctTutor}
                                        style={{ display: "inline" }}
                                    />

                                    <InputWordWrapper>
                                        <Input
                                            type="text"
                                            autoComplete="off"
                                            value={value.input || ""}
                                            onChange={(e) => fillInput(value.id, e.target.value)}
                                            style={{
                                                backgroundColor:
                                                    (language === "Ukr" && (value.input || "") === value.word) ||
                                                        (language === "Eng" &&
                                                            (value.input || "") === value.dictionary)
                                                        ? `${colors.green}`
                                                        : "",
                                            }}
                                        />

                                        <WordWrapper>
                                            <WordSpan onClick={() => clickWord(value.id)}>
                                                {value.id}. {language === "Eng" ? value.word : value.dictionary}
                                            </WordSpan>

                                            <TranslatSpan style={{ visibility: value.display_translat }}>
                                                {language === "Eng" ? value.dictionary : value.word}
                                            </TranslatSpan>
                                        </WordWrapper>
                                    </InputWordWrapper>
                                </Word>

                                {/* {(shouldShowDivider || fallbackDivider) && <LessonDivider />} */}
                                {(shouldShowDivider || fallbackDivider) && (
                                    <>
                                        <LessonLabel>
                                            End of lesson {value.lesson ?? Math.ceil(value.id / 35)}
                                        </LessonLabel>
                                        <LessonDivider />
                                    </>
                                )}
                            </div>
                        );
                    });
                })()}



                {/* {oneThousand.filter(val => val.id <= bottomButtonValue && val.id > (bottomButtonValue - 10)).map((value, index) => (
                        <Word key={index}>
                            <CheckButtonFrame
                                onClick={
                                    canStudentTick ? () => clickInputButton(value.id, value.correctStudent) : undefined
                                }
                                disabled={!canStudentTick}
                                correctStudent={value.correctStudent}
                                correctTutor={value.correctTutor}
                                style={{ display: "inline" }}
                            >
                            </CheckButtonFrame>
                            <CheckButtonFrameTutor
                                onClick={
                                    canTutorTick ? () => clickInputButtonTutor(value.id, value.correctTutor) : undefined
                                }
                                disabled={!canTutorTick}
                                correctStudent={value.correctStudent}
                                correctTutor={value.correctTutor}
                                style={{ display: "inline" }}
                            >
                            </CheckButtonFrameTutor>
                            <InputWordWrapper>
                                <Input
                                    type="text"
                                    autoComplete="off"
                                    value={value.input || ""}
                                    onChange={(e) => fillInput(value.id, e.target.value)}
                                    style={{
                                        backgroundColor:
                                            (language === "Ukr" && (value.input || "") === value.word) ||
                                                (language === "Eng" && (value.input || "") === value.dictionary)
                                                ? `${colors.green}`
                                                : "",
                                    }}
                                />

                                <WordWrapper>
                                    <WordSpan onClick={() => clickWord(value.id)}>
                                        {value.id}. {language === "Eng" ? value.word : value.dictionary}
                                    </WordSpan>
                                    <TranslatSpan style={{ visibility: value.display_translat }}>
                                        {language === "Eng" ? value.dictionary : value.word}
                                    </TranslatSpan>

                                </WordWrapper>
                            </InputWordWrapper>
                        </Word>
                    ))} */}




            </Frame>
            <Frame>
                <LargeButtonsWrapper>
                    <div onClick={() => console.log(oneThousand, role)}>{t.selectHundred}</div>
                </LargeButtonsWrapper>
                <NumberButtonWrapper>

                    {TOP_BUTTONS.map((n) => (
                        <TopButton
                            key={n}
                            selected={n === selectedTop}
                            topNumber={n === selectedTop ? 1 : 0} // we'll use nth-of-type border? better to pass a boolean; see note below
                            style={{
                                backgroundColor: isHundredCompleteForTutor(n) ? `${colors.green}` : "",
                            }}
                            onClick={() => clickTopButton(n)}
                        >
                            {n}
                        </TopButton>
                    ))}

                </NumberButtonWrapper>
                <NumberButtonWrapper>
                    {bottomNumbers.map((n) => (
                        <BottomButton
                            key={n}
                            selected={n === selectedBottom}
                            bottomNumber={n === selectedBottom ? 1 : 0}
                            style={{
                                backgroundColor: isTenCompleteForTutor(n) ? `${colors.green}` : "",
                            }}
                            onClick={() => clickBottomButton(n)}
                        >
                            {n}
                        </BottomButton>
                    ))}

                </NumberButtonWrapper>
                <LargeButtonsWrapper>
                    <PercentButton> <ProgressBarStudent percentStudent={percentStudent} /> <Percent> {t.studentPercent} {percentStudent} % </Percent> </PercentButton>
                    <PercentButton> <ProgressBarTutor percentTutor={percentTutor} /> <Percent> {t.tutorPercent} {percentTutor} % </Percent> </PercentButton>
                </LargeButtonsWrapper>
            </Frame>
        </FramesWrapper>
    )
}

export default FrameComponent

